import { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

const variants = {
  default: 'bg-brand-muted text-brand-dark dark:bg-brand/20 dark:text-brand-light',
  secondary: 'bg-gray-100 text-gray-700 dark:bg-neutral-800 dark:text-gray-300',
  outline: 'border border-gray-200 text-gray-600 dark:border-neutral-700 dark:text-gray-300',
  gold: 'bg-accent-light/40 text-accent-dark dark:bg-accent/20 dark:text-accent-light'
} as const;

export function Badge({ className, variant = 'default', ...props }: HTMLAttributes<HTMLSpanElement> & { variant?: keyof typeof variants }) {
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium', variants[variant], className)}
      {...props}
    />
  );
}
